import { render, staticRenderFns } from "./subNav.vue?vue&type=template&id=f2c69cb4&scoped=true&"
import script from "./subNav.vue?vue&type=script&lang=js&"
export * from "./subNav.vue?vue&type=script&lang=js&"
import style0 from "./subNav.vue?vue&type=style&index=0&id=f2c69cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c69cb4",
  null
  
)

component.options.__file = "subNav.vue"
export default component.exports